
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';

export const ADD_UNDERWRITING_HO = '[UNDERWRITING] Add';
export const REMOVE_UNDERWRITING_HO = '[UNDERWRITING] Remove';


export class AddUnderwritingData implements Action {
    readonly type = ADD_UNDERWRITING_HO;

    constructor(public payload: any) { }
}
// RemovePersonalDetails
export class RemoveUnderwritingData implements Action {
    readonly type = REMOVE_UNDERWRITING_HO;

    constructor(public payload: number) { }
}

export type Actions = AddUnderwritingData | RemoveUnderwritingData;
